export enum ECollateralPage {
  page_collateral_landing = 'page_collateral_landing',
  page_collateral_pending = 'page_collateral_pending',
  page_collateral_rejected = 'page_collateral_rejected',
  page_collateral_approved = 'page_collateral_approved',
  page_global_national_id = 'page_global_national_id',
  page_global_shahkar_exception = 'page_global_shahkar_exception',
  page_collateral_form_confirm = 'page_collateral_form_confirm',
  page_global_otp = 'page_global_otp',
  page_global_sejami_exception = 'page_global_sejami_exception',
}
